<template>
  <div class="-storyboard-hint wt2-text-field">
    <div>
      <div class="-label">Hint:</div>
      <input
        name="hint"
        :value="value"
        @input="$emit('input', $event.target.value)"
      />
    </div>
    <span
      class="wticon wticon-Notice_mark co-tooltip"
      v-tooltip.extend="{
        title:
          'Text you provide here will be used as instructions for the end user\n' +
          'about the related field. ',
        placement: 'right',
        delay: 300,
      }"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'StoryboardHint',
  props: ['value'],
};
</script>

<style lang="scss" scoped>
.-storyboard-hint {
  margin: 10px 0 0 0;
  display: block;

  > .wticon {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    left: auto;
    font-size: 16px;
  }
  position: relative;

  .-label {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translate(0, -50%);
  }
  input {
    background: transparent;
    flex-grow: 1;
    padding-left: 40px !important;
  }
}
</style>
